import React, { useEffect, useState } from 'react';

export const LOGIN_SLIDES = [
  { src: '/images/login/01-wolfenbuettel.jpg', alt: 'Musik & Ballettschule Wolfenbüttel' },
  { src: '/images/login/02-bonn.jpg', alt: 'Musik Akademie Henneberger Bonn' },
  { src: '/images/login/03-obergrafschaft.jpg', alt: 'Musik Akademie Obergrafschaft' },
  { src: '/images/login/04-obergrafschaft-hof.jpg', alt: 'Musik Akademie Obergrafschaft, Innenhof' },
  { src: '/images/login/05-greven.jpg', alt: 'Musik Akademie Greven' },
];

export const SLIDE_INTERVAL_MS = 3000;

/**
 * Standort-Slideshow für die Login-Seite. Wechselt alle 3 Sekunden mit Überblendung.
 * Bei prefers-reduced-motion bleibt das erste Bild stehen.
 */
export default function LoginHeroSlideshow({
  slides = LOGIN_SLIDES,
  intervalMs = SLIDE_INTERVAL_MS,
}) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (slides.length < 2) return undefined;
    const reduced = typeof window !== 'undefined'
      && window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
    if (reduced) return undefined;

    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [slides.length, intervalMs]);

  if (!slides.length) return null;

  return (
    <div
      className="hidden lg:block flex-1 relative overflow-hidden bg-slate-100"
      data-testid="login-hero-slideshow"
      aria-roledescription="Karussell"
      aria-label="Standorte der Musik Akademie"
    >
      {slides.map((slide, i) => (
        <div
          key={slide.src}
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-700 ease-in-out"
          style={{
            backgroundImage: `url('${slide.src}')`,
            opacity: i === index ? 1 : 0,
          }}
          role="img"
          aria-label={slide.alt}
          aria-hidden={i !== index}
          data-testid={`login-hero-slide-${i}`}
          data-active={i === index ? 'true' : 'false'}
        />
      ))}
      <div
        className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2"
        data-testid="login-hero-dots"
        aria-hidden="true"
      >
        {slides.map((slide, i) => (
          <span
            key={slide.src}
            className={`h-1.5 rounded-full transition-all ${
              i === index ? 'w-6 bg-white' : 'w-1.5 bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
}
